// extracted by mini-css-extract-plugin
export default {"container":"_2S2YWW4mSXiK_hhAY2KINq"};